if (document.getElementsByClassName('template-product').length==0) {
const insertBeforeElementBackup = Element.prototype.insertBefore
Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
        return insertBeforeElementBackup.apply(this,args)
}
}

//prevent load font awesome  from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
 if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
   return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove();

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"]').remove();

var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
  if ($(window).width() < 1365) {
    // Filters - Open
    $('.filter-refine').on('click', function () {
      $('.filter').toggleClass('filter--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('.filter-overlay').addClass('filter-overlay--active');
      $('html').addClass('no-scroll');
      return false;
    });

    // Filter - Close
    $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
      $('.filter').removeClass('filter--active');
      $('.filter-overlay').removeClass('filter-overlay--active');
      $('html').removeClass('no-scroll');
      return false;
    });
  }

  // Mobile Nav - Reset all when screen is desktop
  if ($(window).width() > 1279) {
    $('.nav__sub-menu').hide();
    $('.nav__sub-sub-menu').hide();
    $('.nav__plus').removeClass('nav__plus--active');
    $('.nav__link--dropdown').removeClass('active');
    $('.nav__sub-menu__link--dropdown').removeClass('active');
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
  }

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
  });

  // Open Sub Menu - Click Function
  $('.nav__link--dropdown').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
      if($(this).hasClass('active')) {
        $('.nav__link--dropdown').next().slideUp();
        $('.nav__link--dropdown').removeClass('active');
        $(this).children('.nav__plus').removeClass('nav__plus--active');
      } else {
        $('.nav__link--dropdown').removeClass('active');
        $('.nav__link--dropdown').next().slideUp();
        $('.nav__link--dropdown').children('.nav__plus').removeClass('nav__plus--active');
        $(this).next().slideDown();
        $(this).addClass('active');
        $(this).children('.nav__plus').addClass('nav__plus--active');
      }
    }
  });

  // Open Sub Sub Menu - Click Function
  $('.nav__sub-menu__link--dropdown').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
      if($(this).hasClass('active')) {
        $('.nav__sub-menu__link--dropdown').next().slideUp();
        $('.nav__sub-menu__link--dropdown').removeClass('active');
        $(this).children('.nav__plus').removeClass('nav__plus--active');
      } else {
        $('.nav__sub-menu__link--dropdown').removeClass('active');
        $('.nav__sub-menu__link--dropdown').next().slideUp();
        $('.nav__sub-menu__link--dropdown').children('.nav__plus').removeClass('nav__plus--active');
        $(this).next().slideDown();
        $(this).addClass('active');
        $(this).children('.nav__plus').addClass('nav__plus--active');
      }
    }
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Sort Tablet/Desktop
  if ($(window).width() > 599) {
    $('.filter-sort__title').on('click',function(e) {
      e.preventDefault();
    
      var $this = $(this);
    
      if ($this.next().hasClass('filter-sort__list--active')) {
        $this.next().removeClass('filter-sort__list--active');
        $this.next().slideUp(150);
      } else {
        $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
        $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
        $this.next().toggleClass('filter-sort__list--active');
        $this.next().slideToggle(150);
      }

      if ($this.hasClass('filter-sort__title--active')) {
        $this.removeClass('filter-sort__title--active');
      } else {
        $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
        $this.toggleClass('filter-sort__title--active');
      }

    });

    $(document).on('click.resize',function (e) {
      if (!$(e.target).is(".filter-sort *")) {
        $('.filter-sort__list').removeClass('filter-sort__list--active');
        $('.filter-sort__title').removeClass('filter-sort__title--active');
        $('.filter-sort__list').slideUp(150);
      }
    }); 
  }

  // Sort Mobile
  if ($(window).width() < 600) {
    $('.filter-sort').on('click', function () {    
      $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
      $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('html').toggleClass('no-scroll');
      return false;
    });
    $(document).on('click.resize',function (e) {
      if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
        $('.filter-sort__list').removeClass('filter-sort__list--active');
        $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
        $('html').removeClass('no-scroll');
        
      }
    }); 
  }
  previousScroll = 0;
  headerOrgOffset = 0;
  if ($(window).width() > 1365) {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
  } else {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
  }
  
};
// Filters All
$(document).ready(function() {

  loadswatches();
 _initFilter();

  $(document).off('click').on('click',function(e) {
    if (!$(e.target).is(".filter__group *")) {
      $('.filter__list').removeClass('filter__list--active');
      $('.filter__title').removeClass('filter__title--active');
      $('.filter__list').slideUp(150);
    }
  });
});


function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.parent().parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
    } else {
      $this.addClass('filter__title--active');
    }

  });


}
// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){


    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Filter Switch
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

var layouts={
  desktop:[4,3],
  tablet:[3,2],
  mobile:[2,1]
}

function getWindowLayout() {
  var _windowWidth=jQuery(window).width();
  if ( _windowWidth< 767) {
    return layouts.mobile;
  }
  else if (_windowWidth < 1024) {
    return layouts.tablet;
  }
  else {
    return layouts.desktop;
  }
}

function switchLayout(isFirst,isNext) {
  var perRow=1;
  if (isFirst===true) {
    var _perCookie= getCookie("perrow");
    if (_perCookie!=undefined) perRow=parseInt(_perCookie);
  }
  var currentPerRow=$('.filter-switch__grid').get(0).className.match(/show(\d)/);
  if (currentPerRow!=null) {
    perRow=parseInt(currentPerRow[1]); 
  }
  var _currentLayout=getWindowLayout();

  if ($.inArray(perRow, _currentLayout)==-1) {
    perRow=_currentLayout[0];
  } 

  if (isNext===true) {
    perRow=_currentLayout[($.inArray(perRow, _currentLayout) + 1) % _currentLayout.length];
    setCookie("perrow",perRow);     
  }

  if(currentPerRow!=null) {     
    $('.filter-switch__grid').removeClass("filter-switch__grid--show"+currentPerRow[1]);   
    //$('.collection .col').removeClass("show"+currentPerRow[1]);   
  }
  $('.filter-switch__grid').addClass("filter-switch__grid--show"+perRow);  

  $('.collection .col').each(function() {
    var cn=this.className.match('xs-3');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-4');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-6');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-12');
    if (cn!=null) $(this).removeClass(cn[0]);
    var _classname="xs-3";
    switch(perRow) {
      case 1:      
      _classname="xs-12";
      break;
      case 2:
      _classname="xs-6";
      break;
      case 3:
      _classname="xs-4";
      break;
    }
    $(this).addClass(_classname);
  });
}

function layoutSwitch (isFirst) {
  if ($('.filter-switch').length>0) {
    switchLayout(isFirst);

    $('.filter-switch').off('click');
    $('.filter-switch').on('click',function() {
      switchLayout(false,true);
    });
  }
}
$(document).ready(function() {
  $(window).on('load resize', function() {
    layoutSwitch(true);
  });
});

// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').addClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
      //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Product Page - Sticky Button
$(document).on('scroll', function(){
  if ($(window).scrollTop() > 50){
    $('.product-add-mobile').addClass('product-add-mobile--sticky');
  } else {
    $('.product-add-mobile').removeClass('product-add-mobile--sticky');
  }
});

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description-content').toggleClass('collection__description-content--visible');
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Help Accordions
$(document).ready(function() { 
  $('.help__sidebar-header').off('click').on('click', function () {
    $(this).toggleClass('help__sidebar-header--shown');
    $(this).next('.help__sidebar-links').slideToggle(200);
    return false;
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-localization-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'flex').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Zip
$('.product-finance__link--zip').on('click', function () {
  $('.product-finance-popup--zip').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Text Section (Show/Hide)
$('.text__toggle').on('click', function () {
  $(this).prev().slideToggle();
  $(this).children('span').toggle();
});

// Accordion
function productAccordion() { 
  var $tabs = $('.product-accordion');
  if ($tabs.length>0) {
  $tabs.responsiveTabs({
    rotate: false,
    startCollapsed: true,
    collapsible: 'accordion',
    animation: 'slide',
    duration: 300,
    setHash: false,
    disabled: [],
    classes: {
      stateDefault: '',
      stateActive: 'active',
      stateDisabled: '',
      stateExcluded: '',
      container: '',
      ul: 'product-accordion__nav',
      tab: '',
      anchor: 'product-accordion__anchor',
      panel: 'product-accordion__panel',
      accordionTitle: 'product-accordion__title'
    }
  });
  }
}

// Accordion
function faqsAccordion() { 
  var $faqstabs = $('.faqs-accordion');
  if ($faqstabs.length>0) {
  $faqstabs.responsiveTabs({
    rotate: false,
    startCollapsed: true,
    collapsible: 'accordion',
    animation: 'slide',
    duration: 300,
    setHash: false,
    disabled: [],
    classes: {
      stateDefault: '',
      stateActive: 'active',
      stateDisabled: '',
      stateExcluded: '',
      container: '',
      ul: 'faqs-accordion__nav',
      tab: '',
      anchor: 'faqs-accordion__anchor h4',
      panel: 'faqs-accordion__panel',
      accordionTitle: 'faqs-accordion__title'
    }
  });
  }
}


// RESPONSIVE TABS
function _faqsAccordion() {  
  if (window.tabs1) {
    window.tabs1.forEach(x=> {
      $(x).responsiveTabs({
        rotate: false,
        startCollapsed: true,
        collapsible: 'accordion',
        animation: 'slide',
        duration: 300,
        setHash: false,
        disabled: [],
        classes: {
          stateDefault: '',
          stateActive: 'active',
          stateDisabled: '',
          stateExcluded: '',
          container: '',
          ul: 'faqs-accordion__nav',
          tab: '',
          anchor: 'faqs-accordion__anchor',
          panel: 'faqs-accordion__panel',
          accordionTitle: 'faqs-accordion__title'
        }
      });
    });
  }
}

// Swatches
function initSwatches() {
  if (window.swatches!=undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');

    if ($(window).width() > 599) {
    $('.swatches__col').hover(      
      function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          let el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
        }
      },function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).parent().find("[class*='--current']").closest('a').data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  ==  _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
      }
    }
    );
   }
   else {
     $('.swatches__col').on('click',function(e) {
       if ($(this).closest('[data-group-col]').length>0) {
        if ( $('div',this).hasClass('swatches__swatch--current')) return true;
        e.preventDefault();
        $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
        $('div',this).addClass('swatches__swatch--current');
        const _id=$(this).data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
       return false;
       }
     });
 
   }

  }
  
}

function getSwatchData(_handle,callback) {     
  $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+_handle+"/?view=swatch",        
      success: function (data) {
        var _d=data.replace(/\n/g,'').replace(/,}/g,'}');   
        window.swatches=window.swatches || [];
        const h=JSON.parse(_d);
        window.swatches.push(h);
    callback.apply(h);
   }
});
}
function showSwatchData(el,h) {
  var item=$(el).closest('.product-card');
  item.find('.product-card__image').attr("src", h.image);
  item.find('.product-card__image').attr("srcset", "");
  item.find('.product-card__title').text(h.title);
  item.find('.product-card__sku span').text(h.sku);
  item.find('.product-card__price-current').text(h.price);
  item.find('.product-card__price').removeClass('product-card__price--on-sale');
  item.find('.product-card__price').addClass(h.onsale);
  item.find('.product-card__price-compare').text(h.pricecompare);
  item.find('.product-card__price-saving').html(h.saving);
  item.find('.product-card__overlays').replaceWith(h.overlays); 
}

// Run Functions
function _checkafterLoadEvents() {
   window.afterLoadWithEvents.forEach(x=> {
      
      if (x.evt && !$(x.el).is(document)) {
        if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
          $(x.el).off(x.evt+'.'+x.f)
            if (typeof(x.f)=='function') {
              setTimeout(x.f,0);
            }
            else {
            window[x.f].apply();
            }
          window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
        }
      }
      else {
       if (typeof(x.f)=='function') {
          setTimeout(x.f,0);
       }
       else {
         window[x.f].apply();
       }
       window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
       
   });
   if (window.afterLoadWithEvents.length==0) {
     $(window).off('scroll.afterLoad');
   }
}
  function loadswatches(ismissed) {
    if (ismissed!==true) {
     //product detail group swatch    
  $('[data-group]').each(function() {
    let el=$(this);
    $.ajax({
        method    : 'GET',
        url       : document.location.origin+Shopify.routes.root+"collections/all/product-group-code-"+$(this).data('group')+"/?view=product-swatch",        
        success: function (data) {
          el.empty().append(data);
          $('[data-group]').find('[href="'+document.location.pathname+'"] .swatches__swatch').addClass('swatches__swatch--current');
          ProductSwatchHover();            
        }
   });
  });
    }
  let sEl=$('[data-group-col]');    
  if (ismissed!==true) {
    sEl=$('[data-group-col]:not(:has(.swatches__col))');
  }      
  if (sEl.length>0) {
     let tags=[];
    sEl.each(function() {
      const t='Product Group Code|'+$(this).data('group-col');
      if (!tags.includes(t)) tags.push(t);    
    });
    renderSwatchAndOverlay(tags,function() {
      sEl.each(function() {
        let overlayHtml='';
        let htmlItems=[];
        let _tag=$(this).data('group-col');
        let _productsForTag=_productsForTags.filter(p=>p.tag==_tag);        
        let _id=$(this).data('group-col-id');
        if (_productsForTag.length==0) {                  
             _productsForTags.push({
                  tag:_tag,
                  products:_productsData.filter(p=>p.GroupCode==_tag)
             });
             _productsForTag=_productsForTags.filter(p=>p.tag==_tag);
        }
        if (_productsForTag.length>0){   
          _productsForTag[0].products.sort((a, b) => a.id==_id?-1:0).forEach(p=>{          
              let current='';
              let colcurrent='';
              if (_id==p.id){
                  current="swatches__swatch--current";
                  colcurrent="swatches__col--current"; 
                  overlayHtml=p.overlay;
              }
              htmlItems.push(_swatchSettings.item.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{color}}',p.swatchColor).replaceAll('{{name}}',p.swatchName).replace('{{current}}',current).replace('{{colcurrent}}',colcurrent));
          });
          let _html=$(_swatchSettings.template.replace('{{items}}',htmlItems.join('')));
          if (htmlItems.length>4) {
            _html.append('<a class="product-card__swatch-more" href="'+$(this).closest('.product-card').find('.product-card__image-link').attr('href')+'">+</a>');
          }
          $(this).replaceWith(_html);
            //$(this).closest('.product-card').find('.product-card__image-link .product-card__overlays').remove();
            //$(this).closest('.product-card').find('.product-card__image-link').append(overlayHtml);
         }
      });
      window.swatches=[];
      initSwatches();
    });
  }
}
function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
  productAccordion();
  faqsAccordion();
}
  
// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
      let lc = document.createElement('script'); lc.type = 'text/javascript'; 
      lc.src = sc[0];
      sc.splice(0,1);   
      if (sc.length>0) {
        $(lc).on('load',function() {loadScript(sc,callback)});           ;
      }
      else if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
      }
      document.getElementsByTagName('body')[0].appendChild(lc);
  }
  else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
  document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});
  
  
var _productsData=[];
var _productsForTags=[];
var _swatchSettings={
  template:'<div class="swatches product-card__swatches">{{items}}</div>',
  item:`<a class="swatches__col" data-product-id="{{id}}" href="`+Shopify.routes.root+`products/{{url}}" title="{{name}}">
<div class="swatches__swatch {{current}}">
  <span style="background-color: {{color}}"></span>
</div>
<div class="swatches__tag">{{name}}</div>
</a>`,   
  overlay:'<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>'
};
function renderSwatchAndOverlay(tags,callback) {
  if (tags.length>0) {      
  var tagsVar="tag:'"+tags.join("' OR '")+"'";  
    FetchDataWithVariables(`query($tagsVar: String) @inContext(country: `+Shopify.country+`) {
      products( first: 250,query:$tagsVar) {
        edges{
          node {
            id
            handle
            title
            tags
            images(first:2) {    
              edges {       
                node {
                  originalSrc     
                  id
                }
              }
            }
            metafields (identifiers: [ 
             {namespace: "accentuate", key: "overlay"},
             {namespace: "accentuate", key: "top_left_overlay"},
             {namespace: "accentuate", key: "top_right_overlay"},
             {namespace: "accentuate", key: "bottom_overlay"}
            ]){           
              value
              key
              namespace
            }
            variants(first: 100) {
            edges {
              node {       
                price { amount }
                compareAtPrice { amount }
                availableForSale
                id                    
              }
            }
          }
        }
      }  
    }       
  }`,{tagsVar},function(data) {
      //console.log(data);
        
      let Products = data.data.products.edges;
      for(let p of Products) {
            if (_productsData.filter(c=>c.id==p.node.id).length==0) {
        let _product={
              id:p.node.id.replace('gid://shopify/Product/',''),
              handle:p.node.handle,
                  title:p.node.title
          };
              _product.overlays=[]; 

        for(let mf of p.node.metafields) {                   
            if (mf!=null && mf.key.indexOf('_overlay')!=-1) 
                    _product.overlays.push({key:mf.key,value:mf.value});
                  if (mf!=null && mf.key=='overlay') _product.overlays.push({key:mf.key,value:mf.value});
        }
              p.node.tags.forEach(t=>{
                if (t.startsWith("Product Group Code|")) _product.GroupCode=t.replace('Product Group Code|','');
                if (t.startsWith("Swatch Name|")) _product.swatchName=t.replace('Swatch Name|','');
                if (t.startsWith("Swatch Colour|")) _product.swatchColor=t.replace('Swatch Colour|','');                 
              });
      
              
              
              _product.images_info=[];
              for(let v of p.node.images.edges) {   
                _product.images_info.push({
                  id:v.node.id,
                  src:v.node.originalSrc,
                  width:1000,
                  height:1500
                });               
         }
         _product.variants=[];    
              let allowSale=false;
        for(let v of p.node.variants.edges) {   
                if (v.node.availableForSale===true) allowSale=true;
                _product.variants.push({
                  id:v.node.id,
                  price:parseFloat(v.node.price.amount),
                  available:v.node.availableForSale,
                  compare_at_price:v.node.compareAtPrice!=null?parseFloat(v.node.compareAtPrice.amount):null
                });               
        }
              let minPriceVariant=_product.variants.sort((a, b) => a.price - b.price)[0];
        _product.compare_at_price_min=parseFloat(minPriceVariant.compare_at_price);
              _product.price_min=parseFloat(minPriceVariant.price);
               let _overlayHtml=_swatchSettings.overlay;
               let overlayItems=[];
               _product.overlays.forEach(o=> {
                      switch (o.key) {
                        case 'top_left_overlay':  
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','top-left');
                          break;
                        case 'top_right_overlay':
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','top-right');
                          break;
                        case 'bottom_overlay':
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','bottom');
                          break;
                        default:
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','');
                          break;
                      }
                      overlayItems.push(_overlayHtml.replace('{{message}}',o.value));
               });
              _product.overlay=overlayItems.join('');
              if (allowSale) {
          _productsData.push(_product);
          }
        }
      }
      //console.log(_productsData);     
      callback.apply();
    });
  }
  else {
    callback.apply();
  }
  } 

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = "url('" + bg + "')";
    }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__featured-item',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Designer Layout - Smooth Scroll
$(".designers__nav__link").click(function(e) {
  e.preventDefault();
  var targetElement = $(this).attr("href");
  var targetPosition = $(targetElement).offset().top;
  $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
});

// Swiper Video play and pause
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){ 
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
    $this.addClass("swiper-" + index); 
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index); 
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if($this.hasClass('swiper--autoplay')) {
      $autoplay = { delay: 4000 };
    } else {
      $autoplay = "";
    }

    if($this.hasClass('swiper--snap')) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    if($this.find(".swiper-pagination").length) {
      $pagination = '.pagination-' + index;
    } else {
      $pagination = null;
    }
    if($this.find(".swiper-pagination--fraction").length) {
      $pagination_type = 'fraction';
    } else {
      $pagination_type = 'bullets';
    }

    if($this.find(".swiper-button-next").length) {
      $next = '.next-' + index;
    } else {
      $next = null;
    }

    if($this.find(".swiper-button-prev").length) {
      $prev = '.prev-' + index;
    } else {
      $prev = null;
    }    

    if($this.find(".swiper-scrollbar").length) {
      $scrollbar = '.scrollbar-' + index;
    } else {
      $scrollbar = null;
    }
    swiperInstances[index] = new Swiper(".swiper-" + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      navigation: {
        prevEl: $prev,  
        nextEl: $next, 
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      }
    });
    }
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
    productImagesSwiper = new Swiper(".swiper--product-images", {
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination--product-images",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
  });
}

// Promos Slider
$(document).ready(function(){
  (function() {
    var quotes = $(".promos__message");
    var quoteIndex = -1;
    function showNextQuote() {
      ++quoteIndex;
      quotes.eq(quoteIndex % quotes.length)
        .fadeIn(1000)
        .delay(2000)
        .fadeOut(1000, showNextQuote);
    }
    showNextQuote();
  })();
});

// Product Page Swatch Hover
function ProductSwatchHover() {
  const original_colour_id = document.querySelector(".product-swatches__label-name").innerText;
  const swatchEl=document.querySelectorAll(".product-swatches .swatches__col");
  var isHover=false;
  swatchEl.forEach((element) => { element.addEventListener("mouseenter", event => {
    if (!isHover) {
      document.querySelector(".product-swatches__label-name").innerText=event.target.attributes.title.textContent;  
    }
    isHover =true;
  },false);
  });

  swatchEl.forEach((element) => { 
    element.addEventListener("mouseleave", event => {
      document.querySelector(".product-swatches__label-name").innerText=original_colour_id;
      isHover = false;
    },false);
  });
}

function _getWindowLocation() {
  for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], n = 0; n < t.length; n++) e.push(t.charAt(n));
  var i = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
    r = "",
    o = i.replace(/#.*$/, "");
  return o.split("?").length > 1 && (r = o.split("?")[1]).length > 0 && (r = "?" + r), { pathname: window.location.pathname, href: i, search: r };
}

$(document).ready(function(){
  // Popup - Open
  $('[data-popup]').on('click', function () {
    var popup = $(this).attr("data-popup");
    $('#popup-' + popup).addClass('popup--active');
    $('html').addClass('noscroll-popup');
  });

  // Popup - Close
  $('.popup__close').on('click', function () {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('noscroll-popup');
  });

  function converter() {
    var fit = $('.popup__table').attr('data-fit');
    $('.popup__table td[data-standard]').each(function() {
      if($('.popup__table').attr('data-units') == 'cm' ) {
        var cm = $(this).data(fit);
        var cm = cm * 2.54;
        var cm_1dp = Math.round(cm * 10) / 10;
        var cm_1dp = cm_1dp.toFixed(1);
        $(this).text(cm_1dp + 'cm');
      }
      if($('.popup__table').attr('data-units') == 'inches' ) {
        var inches = $(this).data(fit);
        $(this).text(inches + '"');
      }
    });
  }
  converter();
  $('.popup__tabs-link').on('click', function () {
    $(this).siblings().removeClass('popup__tabs-link--active');
    $(this).addClass('popup__tabs-link--active');
    if ($(this).attr("id") == "slim") {
      $('.popup__table').attr('data-fit', 'slim');
      converter();
    }
    if ($(this).attr("id") == "standard") {
      $('.popup__table').attr('data-fit', 'standard');
      converter();
    }
    if ($(this).attr("id") == "inches") {
      $('.popup__table').attr('data-units', 'inches');
      converter();
    }
    if ($(this).attr("id") == "cm") {
      $('.popup__table').attr('data-units', 'cm');
      converter();
    }
  });
});